import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { leadQueryKeys } from "./leadQueryKeys";

export function useQueryLead({
  api,
  leadId,
}: {
  api: ApiType;
  leadId: number | undefined;
}) {
  return useQuery({
    queryKey: leadQueryKeys.detailsNew(leadId),
    queryFn: async () => (await api.leadApi.findById(leadId!)).data,
    enabled: !!leadId,
  });
}
